const posts = {
    posts: [],
    hasMore: false,
    isInitialized: false,
    isLoading: false,
    showAlbum: false,
    total_all: 0,
    selectedPost: {},
    action: '',
    cancelFetchPost: false,
    is_reset: false,
    postMedias: [],
    selectedPostGallery: {},
    keyword: '',
    thankyou: {
        show: false,
        pu: null,
        upgrade: false
    }
};

export default posts;
